import React, {useEffect, useState} from 'react';
import {useLoading} from "../../components/context/LoadingContext";
import {useNavigate} from "react-router-dom";
import {collection, getDocs, query, orderBy} from "firebase/firestore";
import {db, reportsCollectionName} from "../../components/Firebase/Firebase";
import ReportsList from "./ReportsList";

const ReportsPage = () => {
    const [reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useLoading(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchReports();
    }, []);


    async function fetchReports() {
        setIsLoading(true);

        const reportsQuery = query(
            collection(db, reportsCollectionName),
            orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(reportsQuery);
        const reportsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        setReports(reportsList);
        setIsLoading(false);
    }

    return (
        <div className='right-content'>
            <div className='card shadow border-0'>
                <div className="row d-flex align-items-center w-100">
                    <div className="col">
                        <h2 className='hd'>Обращения</h2>
                    </div>
                </div>
                <div className='table-responsive mt-3'>
                    <ReportsList
                        reports={reports}
                        onReportUpdated={fetchReports}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportsPage;